module.exports = __webpack_public_path__ + "c38513f499c3d9fe31e8724958b2438b.png";


//////////////////
// WEBPACK FOOTER
// ./js/sport-betting/components/games/slots/betsoft/assets/805.png
// module id = 1709
// module chunks = 2